module.exports = __webpack_public_path__ + "static/img/adv-logo.0a815063.png";